/* eslint-disable */
import Vue from 'vue'
import store from '@/store/index'

import MainService from './MainService'

class SessionLink {
  parentLocation:any = {}

  constructor () {
    this.parentLocation = store.state.parentLocation
  }

  async getSessionLink (token:any, organizationName:string) {
    const data = {
      route: `ocular/session/link/${token}`,
      params:<any> {
        codec: store.state.support.OT.codec
      }
    }

    if (organizationName) {
      data.params.organizationName = organizationName;
    }

    return MainService.get(data)
  }

  async generateWidgetSessionLinkByCategory (params:any) {
    const storage:any = store.state.storage
    const customer = (storage.room && storage.room.customer) ?? params.customer

    const data = {
      route: `ocular/widget/v2/generate-session`,
      params:<any> {
        ...customer,
        categoryCode: params.categoryCode
      }
    }

    if (params.userCode) {
      data.params.userCode = params.userCode
    }

    if (customer.cellphone) {
      data.params.cellphone = customer.cellphone
    }

    if (customer.email) {
      data.params.email = customer.email
    }

    return MainService.post(data)
  }
}

Vue.prototype.$sessionLink = new SessionLink()
